module.exports = __webpack_public_path__ + "static/media/store.ed31be02.svg";